<template>
  <button class="q-btn q-btn q-btn-sm q-bg-white q-dropdown-toggle q-mb-1 q-rounded-3 q-shadow-sm q-fw-semibold" :class="{'dropdown__open': isOpen}" type="button"
          aria-expanded="false">
    <span class="dropdown-button__label">{{ label }}</span>
    <span class="dropdown-button__icon" aria-hidden="true" />
  </button>
</template>
<script setup lang="ts">
import {defineProps} from 'vue';

defineProps(['label', 'isOpen'])
</script>
<style>
.q-dropdown-toggle {
  display: inline-flex!important;
  align-items: center;
  gap: 0.75em;
  position: relative;
}

.dropdown-button__label {
  flex: 1 1 auto;
  text-align: left;
}

.dropdown-button__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25em;
  height: 1.25em;
  color: #212529;
  transition: transform 0.2s ease;
  position: relative;
}

.dropdown-button__icon::before {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.q-dropdown-toggle:hover, .q-dropdown-toggle:focus{
  border: 1px solid transparent!important;
  background-color: #eaeaea !important;
}
.q-dropdown-toggle:active{
  background-color: #eaeaea!important;
  border: 1px solid transparent!important;
}

.q-dropdown-toggle.dropdown__open .dropdown-button__icon{
  transform: rotate(180deg);
}

</style>
